import React, {Component} from 'react';
import {connect} from "react-redux";
import 'react-bootstrap';

import destinationApi from '../../../api/destinationApi';
import MiddleBanner from '../../../components/MiddleBanner';
import Service from './Service'


class DestinationService extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            arrSrv : []
        }
        this.getDestinationService = this.getDestinationService.bind(this);

        this.destinationID = this.props.id;
        this.lang = props.language.lang_key;
    }

    componentWillMount() { 
        this.getDestinationService();
    }

    componentDidMount() {
        
    }
  
    componentWillUnmount() {
        
    }
    
    componentDidUpdate() {
    }

    componentWillReceiveProps(newProps) {
        if(this.destinationID !== newProps.id) {
            this.destinationID = newProps.id;
            this.getDestinationService();
        }
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getDestinationService();
        }
    }   
  
    getDestinationService() {   
        destinationApi.getDestinationService(this.destinationID, 1).then((json) => {
            if (json.status === 200 && json.data) {
                this.setState({
                    arrSrv : json.data
                })
                window.contentWayPoint(); 
            } else {
                if (json.status === 620) {
                    
                } else {

                }
            }            
        });
    }

    render() {
        if(this.state.arrSrv.length === 0 ){
            return(
                <div>
                    
                </div>
            )
        }
        return (
            <div id="service">
                <MiddleBanner
                    showSearch={false} 
                    page = 'destination_detail'
                    orders = {1}

                />
                {
                    this.state.arrSrv.map((srv, key) => (
                        
                        <Service
                            key = {key}
                            destinationID = {this.destinationID}
                            type_id = {srv.type_id}
                            services = {srv.services}
                            captionTitle = {this.props.captionTitle}
                            type_key = {srv.key}
                        />
                        
                    ))
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(DestinationService);